module.exports = __webpack_public_path__ + "static/media/logo.706600bb.svg";